import { AutogenModelOtherChargeEdi, AutogenRowOtherChargeEdi } from "./autogen/AutogenModelOtherChargeEdi";

export class ModelOtherChargeEdi extends AutogenModelOtherChargeEdi<RowOtherChargeEdi> {
    constructor() {
        super(RowOtherChargeEdi);
    }
}

export class RowOtherChargeEdi extends AutogenRowOtherChargeEdi {
}